import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { payout } from "../../rbac-consts";
import { default as ClientPayoutDetailsContainer } from "./client/PayoutDetailsContainer";
import { default as SupportPayoutDetailsContainer } from "./support/PayoutDetailsContainer";
import { default as AdminPayoutDetailsContainer } from "./admin/PayoutDetailsContainer";
import { default as SuperAdminPayoutDetailsContainer } from "./superAdmin/PayoutDetailsContainer";

const PayoutDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={payout.USER}
        yes={() => (
          <ClientPayoutDetailsContainer match={match} />
        )}
      />
      <Can
        role={user.roles}
        perform={payout.SUPPORT}
        yes={() => (
          <SupportPayoutDetailsContainer match={match} />
        )}
      />
      <Can
        role={user.roles}
        perform={payout.ADMIN}
        yes={() => (
          <AdminPayoutDetailsContainer match={match} />
        )}
      />
      <Can
        role={user.roles}
        perform={payout.SUPER_ADMIN}
        yes={() => (
          <SuperAdminPayoutDetailsContainer match={match} />
        )}
      />
    </>
  );
};

export default PayoutDetailsWrapper;